import Swiper, { Navigation, Pagination } from 'swiper';

export const initHomePageSlider = () => {
    new Swiper('.hero-slider .swiper-container', {
        modules: [Navigation, Pagination],
        autoplay: {
            delay: 5000,
        },
        speed: 400,
        loop: true,
        effect: 'fade',
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
        },
        paginationClickable: true,
        grabCursor: true,
        navigation: {
            nextEl: '.hero-slider__nav-button--next',
            prevEl: '.hero-slider__nav-button--prev',
        },
    });
};

export const initEmployeeSlider = () => {

    const swiper = new Swiper('.swiper', {
        modules: [Navigation],
        // Optional parameters
        //direction: 'vertical',
        loop: true,

        // Navigation arrows
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },

    });
};

export const initRecentNews = () => {
    document.querySelectorAll('.js-recent-news').forEach(function (slider) {
        const swiper = new Swiper(slider, {
            modules: [Navigation, Pagination],
            speed: 400,
            spaceBetween: 16,
            slidesPerView: 1.2,
            navigation: {
                nextEl: slider.parentNode.querySelector('.js-recent-news-next'),
                prevEl: slider.parentNode.querySelector('.js-recent-news-prev'),
            },
            /* nextButton: slider.parentNode.querySelector('.js-recent-news-next'),
            prevButton: slider.parentNode.querySelector('.js-recent-news-prev'), */
            breakpoints: {
                639: {
                    slidesPerView: 2.2
                },
                1150: {
                    slidesPerView: '3.2'
                }
            }
        });
    });
};


export const initGalleryElementCarousel1 = () => {
    document.querySelectorAll('.js-gallery-element-carousel1').forEach(function (carousel) {
        const container = carousel.closest('.nobrainer__elemental__galleryelement__section');
        new Swiper(carousel, {
            modules: [Navigation],
            speed: 400,
            slidesPerView: 1,
            navigation: {
                nextEl: container.querySelector('.js-gallery-element-carousel1-next'),
                prevEl: container.querySelector('.js-gallery-element-carousel1-prev'),
            }
        });
    });
};

export const initGalleryElementCarousel2 = () => {
    document.querySelectorAll('.js-gallery-element-carousel2').forEach(function (carousel) {
        const container = carousel.closest('.nobrainer__elemental__galleryelement__section');
        new Swiper(carousel, {
            modules: [Navigation],
            speed: 400,
            spaceBetween: 8,
            slidesPerView: 2,
            navigation: {
                nextEl: container.querySelector('.js-gallery-element-carousel2-next'),
                prevEl: container.querySelector('.js-gallery-element-carousel2-prev'),
            },
            breakpoints: {
                639: {
                    slidesPerView: 3
                },
                1023: {
                    slidesPerView: 4
                }
            }
        });
    });
};
